"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectUpcomingGenerationReadyToBeMoved = exports.selectUpcomingGenerationIsReady = exports.selectIsMediafileCurrentlyDownloading = exports.selectMediaDirectorySize = exports.selectUpcomingFilesAreLoaded = exports.selectFilesForDownloading = exports.selectUpcomingMediafilesWithErrorState = exports.selectMediafileFileToDownload = exports.selectGenerationFilesWithMediaId = exports.selectMediafilesDownloadingState = exports.selectRequiredMediafileIds = exports.selectCurrentMediafiles = exports.selectUpcomingMediafiles = exports.selectMediafiles = exports.selectMediafile = void 0;
var lodash_flatten_1 = __importDefault(require("lodash.flatten"));
var _kernel_store_types_1 = require("../types");
var Mediafiles_1 = __importDefault(require("../services/Mediafiles"));
var generation_1 = require("./generation");
var mediafilesMeta_1 = require("./mediafilesMeta");
function selectMediafile(id, state) {
    var _a;
    return (_a = state.mediafiles) === null || _a === void 0 ? void 0 : _a[id];
}
exports.selectMediafile = selectMediafile;
function selectMediafiles(state) {
    return state.mediafiles;
}
exports.selectMediafiles = selectMediafiles;
function selectUpcomingMediafiles(state) {
    var _a, _b;
    if (!((_a = state.generation.upcomingSettings) === null || _a === void 0 ? void 0 : _a.mediafiles))
        return [];
    var mediafiles = (_b = state.generation.upcomingSettings.totalMediafiles) !== null && _b !== void 0 ? _b : state.generation.upcomingSettings.mediafiles;
    var upcomingMediafiles = mediafiles
        .map(function (mediafile) { return selectMediafile(mediafile.id, state); })
        .filter(function (mediafile) { return mediafile; });
    return upcomingMediafiles;
}
exports.selectUpcomingMediafiles = selectUpcomingMediafiles;
function selectCurrentMediafiles(state) {
    var _a, _b;
    if (!((_a = state.generation.currentSettings) === null || _a === void 0 ? void 0 : _a.mediafiles))
        return [];
    var mediafiles = (_b = state.generation.currentSettings.totalMediafiles) !== null && _b !== void 0 ? _b : state.generation.currentSettings.mediafiles;
    var currentMediafiles = mediafiles
        .map(function (mediafile) { return selectMediafile(mediafile.id, state); })
        .filter(function (mediafile) { return mediafile; });
    return currentMediafiles;
}
exports.selectCurrentMediafiles = selectCurrentMediafiles;
function selectRequiredMediafileIds(state) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var currentMediafileIds = ((_d = (_b = (_a = state.generation.currentSettings) === null || _a === void 0 ? void 0 : _a.totalMediafiles) !== null && _b !== void 0 ? _b : (_c = state.generation.currentSettings) === null || _c === void 0 ? void 0 : _c.mediafiles) !== null && _d !== void 0 ? _d : []).map(function (mediafile) { return mediafile.id; });
    var upcomingMediafileIds = ((_h = (_f = (_e = state.generation.upcomingSettings) === null || _e === void 0 ? void 0 : _e.totalMediafiles) !== null && _f !== void 0 ? _f : (_g = state.generation.upcomingSettings) === null || _g === void 0 ? void 0 : _g.mediafiles) !== null && _h !== void 0 ? _h : []).map(function (mediafile) { return mediafile.id; });
    return __spreadArray(__spreadArray([], __read(currentMediafileIds), false), __read(upcomingMediafileIds), false);
}
exports.selectRequiredMediafileIds = selectRequiredMediafileIds;
function selectMediafilesDownloadingState(state) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var mediafiles = (_h = (_f = (_d = (_b = (_a = state.generation.upcomingSettings) === null || _a === void 0 ? void 0 : _a.totalMediafiles) !== null && _b !== void 0 ? _b : (_c = state.generation.upcomingSettings) === null || _c === void 0 ? void 0 : _c.mediafiles) !== null && _d !== void 0 ? _d : (_e = state.generation.currentSettings) === null || _e === void 0 ? void 0 : _e.totalMediafiles) !== null && _f !== void 0 ? _f : (_g = state.generation.currentSettings) === null || _g === void 0 ? void 0 : _g.mediafiles) !== null && _h !== void 0 ? _h : [];
    return {
        size: mediafiles.length,
        downloadSize: mediafiles
            .map(function (mediafile) { return selectMediafile(mediafile.id, state); })
            .filter(function (mediafile) { return hasMediafileBeenDownloaded(mediafile); }).length,
    };
}
exports.selectMediafilesDownloadingState = selectMediafilesDownloadingState;
function selectGenerationFilesWithMediaId(state) {
    var upcomingMediafiles = selectUpcomingMediafiles(state);
    var currentMediafiles = selectCurrentMediafiles(state);
    var generationFiles = __spreadArray(__spreadArray([], __read(currentMediafiles), false), __read(upcomingMediafiles), false);
    var filesWithMediaId = generationFiles.reduce(function (sum, mediafile) {
        if (!mediafile)
            return sum;
        var mediafileFilesWithMediaId = mediafile.files.map(function (file) { return (__assign({ mediafileId: mediafile.id }, file)); });
        var selectedFile = [mediafileFilesWithMediaId[0]];
        mediafile.type !== 0 ? sum.unshift.apply(sum, __spreadArray([], __read(selectedFile), false)) : sum.push.apply(sum, __spreadArray([], __read(selectedFile), false));
        return sum;
    }, []);
    return filesWithMediaId;
}
exports.selectGenerationFilesWithMediaId = selectGenerationFilesWithMediaId;
function selectMediafileFileToDownload(mediafileId, state) {
    var mediafile = selectMediafile(mediafileId, state);
    var file = mediafile === null || mediafile === void 0 ? void 0 : mediafile.files[0];
    return file ? __assign(__assign({}, file), { mediafileId: mediafileId }) : null;
}
exports.selectMediafileFileToDownload = selectMediafileFileToDownload;
function selectUpcomingMediafilesWithErrorState(state) {
    var upcomingMediafiles = selectUpcomingMediafiles(state);
    var filesWithMediafileId = upcomingMediafiles.reduce(function (sum, mediafile) {
        if (!mediafile)
            return sum;
        var filesWithMediaId = mediafile.files.map(function (file) { return (__assign({ mediafileId: mediafile.id }, file)); });
        sum.push.apply(sum, __spreadArray([], __read(filesWithMediaId), false));
        return sum;
    }, []);
    return filesWithMediafileId.filter(function (file) {
        return Mediafiles_1.default.getMediafileDownloadDelay(file, state.mediafilesMeta.mediafileDownloadErrors);
    });
}
exports.selectUpcomingMediafilesWithErrorState = selectUpcomingMediafilesWithErrorState;
function selectFilesForDownloading(state) {
    var generationFilesWithMediaId = selectGenerationFilesWithMediaId(state);
    var files = generationFilesWithMediaId
        .filter(function (file) { return !!file && file.cacheState !== _kernel_store_types_1.EMediafileCacheState.CACHE; })
        .filter(function (file) {
        var delay = Mediafiles_1.default.getMediafileDownloadDelay(file, state.mediafilesMeta.mediafileDownloadErrors);
        return !(delay && Mediafiles_1.default.shouldBeDelayed(delay));
    });
    return files;
}
exports.selectFilesForDownloading = selectFilesForDownloading;
function selectUpcomingFilesAreLoaded(state) {
    var files = selectFilesForDownloading(state);
    return files.length === 0;
}
exports.selectUpcomingFilesAreLoaded = selectUpcomingFilesAreLoaded;
function selectMediaDirectorySize(state) {
    return state.global.totalMediafilesSize;
}
exports.selectMediaDirectorySize = selectMediaDirectorySize;
function selectIsMediafileCurrentlyDownloading(state) {
    var _a;
    return Boolean((0, lodash_flatten_1.default)(Object.values((_a = state.mediafiles) !== null && _a !== void 0 ? _a : {}).map(function (mediafile) { return mediafile.files; })).find(function (file) { return file.cacheState === _kernel_store_types_1.EMediafileCacheState.DOWNLOADING; }));
}
exports.selectIsMediafileCurrentlyDownloading = selectIsMediafileCurrentlyDownloading;
function selectUpcomingGenerationIsReady(state) {
    var _a;
    var _b = {
        settings: (0, generation_1.selectUpcomingGenerationSettings)(state),
        upcomingMediafiles: selectUpcomingMediafiles(state),
        upcomingMediafilesWithErrors: selectUpcomingMediafilesWithErrorState(state),
        upcomingLoaded: selectUpcomingFilesAreLoaded(state),
    }, upcomingMediafiles = _b.upcomingMediafiles, upcomingLoaded = _b.upcomingLoaded, upcomingMediafilesWithErrors = _b.upcomingMediafilesWithErrors, settings = _b.settings;
    return ((_a = (settings &&
        upcomingLoaded &&
        upcomingMediafiles.length / 2 > upcomingMediafilesWithErrors.length)) !== null && _a !== void 0 ? _a : false);
}
exports.selectUpcomingGenerationIsReady = selectUpcomingGenerationIsReady;
function selectUpcomingGenerationReadyToBeMoved(state) {
    var upcomingSettings = (0, generation_1.selectUpcomingGenerationPresent)(state);
    if (!upcomingSettings)
        return false;
    var upcomingIds = new Set((0, generation_1.selectUpcomingGenerationMediafileIds)(state));
    var generationDownloadQueue = (0, mediafilesMeta_1.selectMediafileDownloadQueue)(state).filter(function (fileId) {
        return upcomingIds.has(fileId);
    });
    var upcomingErrors = new Set((0, mediafilesMeta_1.selectDelayedMediafileIds)(state).filter(function (fileId) { return upcomingIds.has(fileId); }));
    var downloadQueueWithoutErrors = generationDownloadQueue.filter(function (id) { return !upcomingErrors.has(id); });
    return downloadQueueWithoutErrors.length === 0 && upcomingIds.size / 2 > upcomingErrors.size;
}
exports.selectUpcomingGenerationReadyToBeMoved = selectUpcomingGenerationReadyToBeMoved;
function hasMediafileBeenDownloaded(mediafile) {
    var _a;
    return Boolean((_a = mediafile === null || mediafile === void 0 ? void 0 : mediafile.files) === null || _a === void 0 ? void 0 : _a.some(function (file) {
        return file.cacheState === _kernel_store_types_1.EMediafileCacheState.CACHE;
    }));
}
//# sourceMappingURL=mediafiles.js.map